import React, { FC } from 'react';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { ClientUrlParamsConfiguration } from 'api';

interface IProps {
  item: ClientUrlParamsConfiguration;
}

const Names: FC<IProps> = ({ item }) => {
  const { key, value, dynamic_value, value_options } = item;

  function getValues() {
    return value || dynamic_value || (Array.isArray(value_options) && value_options.join(', '));
  }

  return (
    <Grid xs={4}>
      <Typography variant="subtitle2">{key}</Typography>
      <Typography color="textSecondary">{getValues()}</Typography>
    </Grid>
  );
};

export default Names;
